<template>
    <div class="col-md-12">
        <div class="page-header-style">
            <ul class="nav nav-pills">
                <li class="disabled"><h4 style="margin-left:15px; margin:10px" class="text-primary"><b>{{patientid !== undefined ? "Edit" : "Create"}} Patient -  {{ carehomeName }}</b></h4></li>
            </ul>
            <!--<hr style="margin-top:0px" />-->

        </div><br />
        <form class="form-horizontal">
            <fieldset>
                <!--<legend>{{patientid !== undefined ? "Edit" : "Create"}} Patient<h3 style="margin:0px" class="text-primary pull-right"><em>{{carehomeName}} </em></h3></legend>-->
               
                <!--<div class="row">
                    <div class="col-md-6">
                        <forminput v-bind:controller="controller.title"></forminput>
                    </div>
                 
                </div><hr />-->
                <div class="row">
                    <div class="col-md-6">
                        <forminput v-bind:controller="controller.title"></forminput>
                        <forminput v-bind:controller="controller.firstName"></forminput>
                        <forminput v-bind:controller="controller.middleName"></forminput>
                        <forminput v-bind:controller="controller.lastName"></forminput>
                        <hr />

                        <datepicker v-bind:controller="controller.dob"></datepicker>
                        <formselect v-bind:controller="controller.sex" v-bind:options="sexOptions"></formselect>
                        <formimage v-model="controller.image" :update-image-data="updateImage"></formimage>
                    </div>
                    <div class="col-md-6">
                        <forminput v-bind:controller="controller.nhsnumber"></forminput>
                        <formtextarea v-bind:controller="controller.notes"></formtextarea>
                        <formtextarea v-bind:controller="controller.allergies"></formtextarea>
                        <hr />
                        <forminput v-bind:controller="controller.gpname"></forminput>
                        <formtextarea v-bind:controller="controller.gpaddress"></formtextarea>
                        <forminput v-bind:controller="controller.gppostcode"></forminput>
                        <forminput v-bind:controller="controller.gpphone"></forminput>
                    </div>
                    </div>
</fieldset>
            <hr />
            <!--<div class="form-group" v-bind:class="{ 'has-error' : controller.hasError,'has-warning' : controller.hasWarning ,'has-success' : controller.hasSuccess}">
                <button class="btn btn-button btn-primary" :disabled="controller.hasError" type="button" @click.self.prevent="submit">{{controller.IsNew ? "Create" : "Update"}}</button>
                <button class="btn btn-button" type="button" @click.self.prevent="cancel">Cancel</button>
                <span class="help-block" v-if="controller.hasWarning || controller.hasError">
                    <i class="fa" v-bind:class="{ 'fa-exclamation-circle' : controller.hasError,'fa-exclamation-triangle' : controller.hasWarning }"></i>
                    <small>{{controller.message}}</small>
                </span>
            </div>-->
            <div class="form-group" v-bind:class="{ 'has-error' : controller.hasError,'has-warning' : controller.hasWarning ,'has-success' : controller.hasSuccess}">
                <!--<a class="btn btn-primary" :disabled="controller.hasError" @click.prevent.self="save()">Submit</a>-->
                <WorkerButton :disabled="controller.hasError" :submit="submit" task="Patient Created" :callback="submitFinished"></WorkerButton>
                <a href="#" class="btn btn-warning" @click.self.prevent="reset">Reset</a>
                <span class="help-block">{{controller.message}}</span>
            </div>
        </form>
    </div>
</template>

<script>

    import $ from 'jquery';
    import forminput from "./../../corecontrols/forminput/forminput.scp.html"
    import datepicker from "./../../corecontrols/datepicker/datepicker.scp.html"
    import formselect from "./../../corecontrols/formselect/formselect.scp.html"
    import formtextarea from "./../../corecontrols/formtextarea/formtextarea.scp.html"
    import formimageupload from "./../../corecontrols/formimageupload/formimageupload.scp.html"
    import formimage from "./../../corecontrols/formimage/formimage.scp.html"
    import WorkerButton from "../../corecontrols/workerbutton/workerbutton.scp.html"
    import carehomewardlist from "./../../carehome-wards/list/carehome-ward-list.scp.html"
    import { CarehomeDto } from './../../../dto/carehomedto'
    import Dal from './../../../scripts/dataaccess'

    import { CarehomePatientCreateController } from './carehome-patient-create-controller.ts'


    export default {
        props: ['carehomeid', 'patientid'],
        data: function () {

            return {
                updateImage: false,
                controller: new CarehomePatientCreateController(),
                carehomeName: null,
                sexOptions: ["Male", "Female", "Unspecified"]
            }
        },
        created: function () {
            console.log("Patient Editor Loaded with params : ", this.carehomeid, this.patientid)
            var dal = new Dal();

            dal.GetCarehome(this.carehomeid).then(ch => this.carehomeName = ch.name);

            if (this.patientid) {

                
                dal.GetPatient(this.patientid).then(patient => {
                    console.log("dob : ", patient.dob)
                    this.controller = new CarehomePatientCreateController(this.carehomeid, patient)
                    console.log("dob : ", this.controller.dob.value)
                })

            }
        },
        mounted: function () {
            console.log("Patient Editor mounte with params : ", this.carehomeid, this.patientid)
        },
        methods: {
            submit: function () {
                this.updateImage = !this.updateImage;
                return this.controller.submit();
            },
            submitFinished: function () {
                history.back()
            },
            reset: function () {
                $(this.$el).find("form").trigger("reset");
            }
        },
        components: {
            forminput,
            datepicker,
            formselect,
            formtextarea,
            formimageupload,
            formimage,
            WorkerButton
        }
    }

</script>


// WEBPACK FOOTER //
// carehome-patient-create.scp.html?6bab1742